import Image from 'next/legacy/image';
import { classes } from 'shared';
import longLogo from '../../assets/general/bfk-logo-horiz-fc.svg';
import whiteLogoLong from '../../assets/general/bfk-logo-horiz-w.svg';
import Logo from '../../assets/logo.svg';

export function LogoMain({ className, defer }: { className?: string; defer?: boolean }) {
  return (
    <div className={classes(className, 'relative aspect-[94/75]')}>
      <Image priority={!defer} src={Logo} alt="Logo" layout="fill" objectFit="contain" className="max-w-full" />
    </div>
  );
}

export function LogoMainLongWhite({ className }: { className?: string }) {
  return (
    <div className={classes(className, 'relative aspect-[300/131]')}>
      <Image priority src={whiteLogoLong} alt="Logo" layout="fill" objectFit="contain" className="max-w-full" />
    </div>
  );
}

export function LogoMainLong({ className }: { className?: string }) {
  return (
    <div className={classes(className, 'relative aspect-[300/131]')}>
      <Image priority src={longLogo} alt="Logo" layout="fill" objectFit="contain" className="max-w-full" />
    </div>
  );
}
